import { createChildInstanceFromDefinition } from "./instanceTreeUtils";
import { evaluateExpression } from "./evaluateBindings";

export function buildChildrenFromLayout(definition, definitions) {
  if (!definition.layout || definition.layout.type === "none") return [];

  return (definition.layout.children || []).map((childRule) => {
    const def = definitions.find(
      (d) => d.category === childRule.category
    );

    if (!def) return null;

    const instance = createChildInstanceFromDefinition(def);

    instance.role = childRule.role;

    instance.transform = {
      position: {
        x: evaluateExpression(childRule.x || "0"),
        y: evaluateExpression(childRule.y || "0"),
        z: evaluateExpression(childRule.z || "0"),
      },
      rotation: {
        x: evaluateExpression(childRule.rx || "0"),
        y: evaluateExpression(childRule.ry || "0"),
        z: evaluateExpression(childRule.rz || "0"),
      },
    };

    return instance;
  }).filter(Boolean);
}